
import Home from '@/components/home.vue'
export default {
	components: {
		Home,
	},
}
